import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import PageLoader from './component/loader/PageLoader';

import { useAppBootstrap } from './utils/bootstrap';
import { FirebaseProvider } from './provider/FirebaseProvider';
import { ThemeContextProvider } from './provider/ThemeProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

const BootstrapApp = () => {
  const { bootstrapped } = useAppBootstrap();

  return (
    <PageLoader loading={!bootstrapped}>
      <App />
    </PageLoader>
  );
};

root.render(
  <React.StrictMode>
    <FirebaseProvider>
      <ThemeContextProvider>
        <BootstrapApp />
      </ThemeContextProvider>
    </FirebaseProvider>
  </React.StrictMode>
);